import { CanDeactivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { GtmService } from '@seven1/angular/gtm';

export const routeChangeDeactivateGuard: CanDeactivateFn<unknown> = (
  component,
  currentRoute,
  currentState,
  nextState,
) => {
  const gtmService = inject(GtmService);
  gtmService.routingDeactivation('', currentState.url);
  return true;
};
